import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { LanguageProvider } from './hooks/useLanguage';
import { ToastProvider } from './components/ui/Toast';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-610">
    <LanguageProvider data-id="element-611">
      <ToastProvider data-id="element-612">
        <App data-id="element-613" />
      </ToastProvider>
    </LanguageProvider>
  </React.StrictMode>);